export const environment = {
  apiBaseUrl: 'https://api.test.smartcinemahub.com/api',
  apiKey: '03feba6f-314f-4969-9544-108f7727617e',
};
